interface SquiggleProps {
  color?: string;
  className?: string;
}

const Squiggle = ({ color = 'var(--gss-yellow)', className = '' }: SquiggleProps) => (
  <svg
    className={className}
    viewBox="0 0 200 12"
    preserveAspectRatio="none"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M0 8 Q25 0 50 8 T100 8 T150 8 T200 8"
      stroke={color}
      strokeWidth="4"
      strokeLinecap="round"
    />
  </svg>
);

export default Squiggle;
